<div class="card-header">
  <div>
    <div class="smart-actions">
      @for (smartAction of this.smartActions; track smartAction) {
        @if (smartAction.id == 'similarLeads') {
          @if (smartAction.count != 1) {
            <a
              class="smart-link"
              (click)="onSmartLinkClick(smartActions.indexOf(smartAction))"
              >
              <i class="mdi mdi-{{ smartAction.icon }}"></i>
              <div class="ms-1">
                <div class="smart-value">
                  {{ smartAction.count }}
                </div>
                <div class="smart-unit">
                  {{ smartAction.label | translate }}
                </div>
              </div>
            </a>
          }
        } @else {
          @if (smartAction.count != 0) {
            <a
              class="smart-link"
              (click)="onSmartLinkClick(smartActions.indexOf(smartAction))"
              >
              <i class="mdi mdi-{{ smartAction.icon }}"></i>
              <div class="ms-1">
                <div class="smart-value">
                  {{ smartAction.count }}
                </div>
                <div class="smart-unit">
                  {{ smartAction.label | translate }}
                </div>
              </div>
            </a>
          }
        }
      }
    </div>
  </div>
</div>
